import type { ReactNode } from 'react';
import { Squiggle } from './Decorations';

/**
 * Section heading with the accented second half the old site used ("Get <em>in touch</em>
 * with me."), plus a hand-drawn underline.
 */
export function SectionHeading({
  children,
  eyebrow,
  align = 'center',
}: {
  children: ReactNode;
  eyebrow?: string;
  align?: 'center' | 'left';
}) {
  const alignment = align === 'center' ? 'items-center text-center' : 'items-start text-left';

  return (
    <div className={`flex flex-col ${alignment} gap-3`}>
      {eyebrow && (
        <span className="font-display text-sm font-semibold tracking-[0.18em] text-mint-700 uppercase">
          {eyebrow}
        </span>
      )}
      <h2 className="text-3xl leading-tight sm:text-4xl">{children}</h2>
      <Squiggle className="text-blush-300" />
    </div>
  );
}

/** The pink emphasis span used inside headings. */
export function Accent({ children }: { children: ReactNode }) {
  return <span className="text-blush-600">{children}</span>;
}
